import { render, staticRenderFns } from "./AutoResizeTextarea.vue?vue&type=template&id=0ab992aa&scoped=true"
import script from "./AutoResizeTextarea.vue?vue&type=script&lang=js"
export * from "./AutoResizeTextarea.vue?vue&type=script&lang=js"
import style0 from "./AutoResizeTextarea.vue?vue&type=style&index=0&id=0ab992aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab992aa",
  null
  
)

export default component.exports